module.exports = __webpack_public_path__ + "static/shannaTransparent-0cbc4dbce74efa8651f52789de8b6d3d.png";